import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import React, { useState } from 'react'
import 'react-tabs/style/react-tabs.css';
import DataChanges from './dataChanges'
import LoginHistory from './logins';
import BgTaskLogsView from './bgTasks';
import CronLogsView from './crons';
import SyncLogsView from './syncs';
import './style.scss';

export const TabsLogs = () => {
  const [tabIndex, setTabIndex] = useState(0);
  const [cronLogId, setCronLogId] = useState();
  const [changeTab, setChangeTab] = useState(false);

  const getParamsData = (data) => {
    setTabIndex(4)
    setCronLogId(data._id)
    setChangeTab(false)
  };

  /* const tabSelect = (key) => {

    switch (key) {
      case 0:
        
        break;
    
      default:
        break;
    }

    if (key === 0) {
      setTabIndex(0)
    } else if (key === 1) {
      setTabIndex(1)
    } else if (key === 2) {
      setTabIndex(2)
    } else if (key === 3) {
      setTabIndex(3)
    } else if (key === 4) {
      setTabIndex(4)
      setChangeTab(true)
    } else if (key === 5) {
      setTabIndex(5)
    }else if (key === 6) {
      setTabIndex(6)
    }
  } */

    const handleTabSelect = (index) => {
      //if index is not a number, return. 
      // Because each change in the tab will trigger this function with the event object,
      // and event while typing in the input.
      if(typeof index !== 'number') return;
  
      setTabIndex(index);
    }

  return (
    <>
      <div className="table-header d-flex align-items-center justify-content-between">
        <h3 className="heading_h3"> Logs </h3>
      </div>
      <Tabs selectedIndex={tabIndex} onSelect={handleTabSelect}>
        <TabList>
          <Tab>Login History</Tab>
          <Tab>Data Changes</Tab>
          {/* <Tab>Background Tasks</Tab> */}
          <Tab>Cron Jobs</Tab>
          <Tab>Sync Logs</Tab>
        </TabList>

        <TabPanel>
          <LoginHistory></LoginHistory>
        </TabPanel>
        <TabPanel>
          <DataChanges></DataChanges>
        </TabPanel>
        {/* <TabPanel>
          <BgTaskLogsView></BgTaskLogsView>
        </TabPanel> */}
        <TabPanel>
          <CronLogsView getParamsData={getParamsData}></CronLogsView>
        </TabPanel>
        <TabPanel>
          <SyncLogsView changeTab={changeTab} cronLogId={cronLogId}></SyncLogsView>
        </TabPanel>
      </Tabs>
    </>
  )
}




